<template>
  <section class="l-section wpb_row height_small width_full mpc-row"
           style="margin-top: 30px !important;">
    <div class="l-section-h i-cf">
      <div class="g-cols type_default valign_top">
        <div class="vc_col-sm-12 wpb_column vc_column_container mpc-column">
          <div class="vc_column-inner  vc_custom_1489709180672">
            <div class="wpb_wrapper">
              <div class="g-cols wpb_row type_default valign_top vc_inner mpc-row">
                <div class="vc_col-sm-6 wpb_column vc_column_container mpc-column">
                  <div class="vc_column-inner">
                    <div class="wpb_wrapper">
                      <div class="wpb_text_column">
                        <div class="wpb_wrapper"
                             style="text-align: justify;"
                             v-html="col1" data-html></div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="vc_col-sm-6 wpb_column vc_column_container mpc-column">
                  <div class="vc_column-inner">
                    <div class="wpb_wrapper">
                      <div class="wpb_text_column ">
                        <div class="wpb_wrapper"
                             style="text-align: justify;"
                             v-html="col2" data-html></div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'Description',
  props: {
    col1: {
      type: String,
      default: ''
    },
    col2: {
      type: String,
      default: ''
    }
  }
}
</script>

<style>

</style>
